import * as React from "react";
import { Box, Button, IconButton, List, ListItemButton, ListItemText, Typography } from "@mui/material";
import AddCommentIcon from "@mui/icons-material/AddComment";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";

export const RECENTS_LIMIT = 10;

export default function ChatSidebar({ chats, activeChatUid, view, onNewChat, onShowChats, onSelectChat, onRequestDelete, onToggleCollapse }) {
    const recents = chats.slice(0, RECENTS_LIMIT);

    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100%", p: 1.5 }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
                <Typography variant="h6" color="primary" sx={{ fontWeight: 700, pl: 1 }}>
                    ieQip
                </Typography>
                <IconButton aria-label="Collapse sidebar" onClick={onToggleCollapse} size="small">
                    <MenuOpenIcon />
                </IconButton>
            </Box>

            <Button startIcon={<AddCommentIcon />} onClick={onNewChat} sx={{ justifyContent: "flex-start", px: 1, mb: 0.5 }}>
                New chat
            </Button>
            <Button
                startIcon={<ChatBubbleOutlineIcon />}
                onClick={onShowChats}
                color={view === "history" ? "primary" : "inherit"}
                sx={{ justifyContent: "flex-start", px: 1 }}
            >
                Chats
            </Button>

            <Typography variant="caption" color="text.secondary" sx={{ px: 1, mt: 2, mb: 0.5 }}>
                Recents
            </Typography>
            <List dense disablePadding sx={{ overflowY: "auto", flex: 1 }}>
                {recents.map((chat) => (
                    <ListItemButton
                        key={chat.ai_assistant_chat_uid}
                        selected={chat.ai_assistant_chat_uid === activeChatUid}
                        onClick={() => onSelectChat(chat)}
                        sx={{ borderRadius: 1, pr: 1 }}
                    >
                        <ListItemText
                            primary={chat.title || "New chat"}
                            primaryTypographyProps={{ noWrap: true, variant: "body2" }}
                        />
                        <IconButton
                            size="small"
                            aria-label="Delete chat"
                            onClick={(event) => {
                                event.stopPropagation();
                                onRequestDelete(chat);
                            }}
                        >
                            <DeleteOutlineIcon fontSize="small" />
                        </IconButton>
                    </ListItemButton>
                ))}
            </List>
            {chats.length > RECENTS_LIMIT && (
                <Button size="small" onClick={onShowChats} sx={{ justifyContent: "flex-start", mt: 0.5 }}>
                    View all
                </Button>
            )}
        </Box>
    );
}
